/**
 * Сетка пар «подпись: значение» карточек биллинга (платёж, детали
 * контракта): одна колонка на телефоне, две на десктопе, как в PaymentDetails.
 */
export const GRID_SX = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
  gap: 2,
} as const;
